import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { Shell } from '@/components/layout/Shell';
import { DriverProtectedRoute } from './guards';

import { LoginPage as DriverLogin } from '@/pages/driver/Login';
import { OnboardingPage as DriverOnboarding } from '@/pages/driver/Onboarding';
import { DashboardPage as DriverDashboard } from '@/pages/driver/Dashboard';
import { ProfilePage as DriverProfile } from '@/pages/driver/Profile';
import { VehiclesPage } from '@/pages/driver/Vehicles';
import { VehicleDetailPage } from '@/pages/driver/VehicleDetail';
import { AvailabilityPage } from '@/pages/driver/Availability';
import { DocumentsPage } from '@/pages/driver/Documents';
import { OpportunitiesPage } from '@/pages/driver/Opportunities';
import { ReferralsPage } from '@/pages/driver/Referrals';
import { GamificationPage } from '@/pages/driver/Gamification';
import { SettingsPage as DriverSettings } from '@/pages/driver/Settings';

export function DriverRoutes() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="login" element={<DriverLogin />} />
        <Route
          path="onboarding"
          element={
            <DriverProtectedRoute>
              <DriverOnboarding />
            </DriverProtectedRoute>
          }
        />
        <Route
          element={
            <DriverProtectedRoute>
              <Shell />
            </DriverProtectedRoute>
          }
        >
          <Route path="dashboard" element={<DriverDashboard />} />
          <Route path="profile" element={<DriverProfile />} />
          <Route path="vehicles" element={<VehiclesPage />} />
          <Route path="vehicles/:id" element={<VehicleDetailPage />} />
          <Route path="availability" element={<AvailabilityPage />} />
          <Route path="documents" element={<DocumentsPage />} />
          <Route path="opportunities" element={<OpportunitiesPage />} />
          <Route path="referrals" element={<ReferralsPage />} />
          <Route path="gamification" element={<GamificationPage />} />
          <Route path="settings" element={<DriverSettings />} />
          <Route index element={<DriverDashboard />} />
        </Route>
        <Route path="" element={<Navigate to="/driver/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}
